import { render, staticRenderFns } from "./business.vue?vue&type=template&id=5891460d&scoped=true&"
import script from "./business.vue?vue&type=script&lang=js&"
export * from "./business.vue?vue&type=script&lang=js&"
import style0 from "./business.vue?vue&type=style&index=0&id=5891460d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5891460d",
  null
  
)

export default component.exports